export const titleSx = {
  textTransform: 'uppercase',
  color: '#9e9e9e',
}

export const notificationContainerSx = {
  padding: '8px 16px 16px 16px',
  border: '1px solid #E0E0E0',
  boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.25)',
  backgroundColor: '#F6F6F6',
  borderRadius: '4px',
}

export const menuItemSx = {
  pl: 0,
  '&:hover': {
    backgroundColor: 'transparent',
  },
}

export const dotationImageSx = {
  position: 'absolute',
  top: '38%',
  right: '45px',
}

export const autocompleteStyles = {
  autocompleteField: {
    borderRadius: 8,
  },
  autocompleteFieldInput: {
    padding: '0 4px !important',
  },
  popupIndicator: {
    padding: 0,
    marginRight: '16px',
    '&:hover': {
      background: 'transparent',
    },
  },
  autocompleteListbox: {
    padding: 0,
  },
  currencyName: {
    fontSize: '1rem',
    lineHeight: '28px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '300px',
    fontWeight: '400 !important',
  },
  menuItem: {
    borderRadius: '8px',
    width: '100%',
    background: '#FFF',
  },
  menuItemSelected: {
    background: '#EBF4FF !important',
  },
  option: {
    borderRadius: '8px',
    backgroundColor: '#F6ECDF !important',
    padding: 0,
    margin: '2px 0',
  },
  paper: {
    padding: '12px',
    margin: '6px 0',
    boxShadow: (props: any) =>
      `0 0 0 2px ${
        props.borderColor ? props.borderColor : '#A1A1A1'
      }, 0px 12px 16px -8px rgba(52, 52, 52, 0.12)`,
  },
}
